import mutationTypes from './mutations'
import ActivityService from '@/services/activityService'
import { request } from '@/utils/request'

const actions = {
    setLoginHint({ commit }, hint) {
        commit(mutationTypes.SET_LOGIN_HINT, hint)
    },
    clearLoginHint({ commit }) {
        commit(mutationTypes.CLEAR_LOGIN_HINT)
    },
    flash({ commit }, message) {
        commit(mutationTypes.APPEND_FLASH_MESSAGE, message)
    },
    setRightDrawerOpen({ commit }, open) {
        commit(mutationTypes.SET_RIGHT_DRAWER_OPEN, open)
    },
    setRightRailOpen({ commit }, open) {
        commit(mutationTypes.SET_RIGHT_RAIL_OPEN, open)
    },
    closeDrawers({ commit }) {
        commit(mutationTypes.CLOSE_DRAWERS)
    },
    async showActivityDetails({ commit }, id) {
        const details = await ActivityService.getDetails(id)

        if (details) {
            commit(mutationTypes.SHOW_RIGHT_DRAWER_CONTENT, { type: 'activity', item: details })
        }
    },
    showDataEntryNotes({ commit }) {
        commit(mutationTypes.SHOW_RIGHT_DRAWER_CONTENT, { type: 'data-entry-notes' })
    },
    showTaskQueue({ commit }, item) {
        commit(mutationTypes.SHOW_RIGHT_DRAWER_CONTENT, { type: 'task-queue', item })
    },
    showTaskItem({ commit }, item) {
        commit(mutationTypes.SHOW_RIGHT_DRAWER_CONTENT, { type: 'task-item', item: item })
    },
    setCurrentEntity({ getters, commit }, entity) {
        commit(mutationTypes.SET_CURRENT_ENTITY, entity)

        // see if we need to switch the task panel in the right sheet
        const taskItem = getters.currentTaskItem

        if (!taskItem) {
            return
        }

        const taskItemEntity = taskItem.entity

        if (entity.type === taskItemEntity.type && entity.id === taskItemEntity.id) {
            commit(mutationTypes.SHOW_RIGHT_DRAWER_CONTENT, { type: 'task-queue', item: taskItem })
        }
    },
    clearCurrentEntity({ commit }) {
        commit(mutationTypes.CLEAR_CURRENT_ENTITY)
    },
    clearRightDrawer({ commit }) {
        commit(mutationTypes.SET_RIGHT_DRAWER_OPEN, false)
        setTimeout(() => commit(mutationTypes.CLEAR_RIGHT_DRAWER), 500)
    },
    openPopover({ commit }, popover) {
        commit(mutationTypes.SET_POPOVER_CONTENT, popover)
        commit(mutationTypes.SET_POPOVER_OPEN, true)
    },
    closePopover({ state, commit }, popover) {
        if (popover == null || state.popover.content === popover) {
            commit(mutationTypes.SET_POPOVER_OPEN, false)
        }
    },
    closeSearchModal({ state, commit }) {
        state.searchModal.open = false
        commit(mutationTypes.SET_POPOVER_OPEN, false)
    },
    async loadGeography({ state, commit }) {
        if (state.geography.countries.length === 0) {
            commit(mutationTypes.SET_COUNTRIES, await request.get('/api/reference/countries'))
        }
    },
    async loadExchanges({ state, commit }) {
        if (state.markets.exchanges.length === 0) {
            commit(mutationTypes.SET_EXCHANGES, await request.get('/api/reference/exchanges'))
        }
    },
    async loadJobRolesConfiguration({ state, commit }) {
        if (state.jobRoles.options.length === 0) {
            const configuration = await request.get('/api/manage/job-roles/configuration')
            const options = []
            configuration.roles.forEach((role, index) => {
                if (configuration.roles[index - 1]?.group !== role.group) {
                    options.push({ text: `--- ${role.group} Roles ---`, disabled: true })
                }
                options.push({ text: `${role.code} - ${role.description}`, value: role.code })
            })
            commit(mutationTypes.SET_JOB_ROLES_CONFIGURATION, { options })
        }
    },
    showCustomWorkModal({ state, commit }, params) {
        state.customWork.show(params)
        commit(mutationTypes.SET_SEARCH_MODAL_OPEN, false)
        commit(mutationTypes.SET_POPOVER_OPEN, false)
    },
}

const types = Object.getOwnPropertyNames(actions).reduce((map, property) => {
    map[property] = property
    return map
}, {})

export { types as default, actions }
